import cssGlobal from '../../utils/cssGlobal';

export default cssGlobal({
  '.customPagination .ui-paginator a': {
    width: 'auto',
    minWidth: 40,
    paddingLeft: 2,
    paddingRight: 2
  }
});


// WEBPACK FOOTER //
// ./src/containers/list/customPagination.styles.js